import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-mfa-not-enabled-popup',
    templateUrl: './mfa-not-enabled-popup.component.html',
    styleUrls: ['./mfa-not-enabled-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class MfaNotEnabledPopupComponent {
    constructor(public activeModal: NgbActiveModal) {}
}
